import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getMaintenanceTypeList as getMaintenanceTypeListApi,
	getMaintenanceType as getMaintenanceTypeApi,
	addNewMaintenanceType as addNewMaintenanceTypeApi,
	updateMaintenanceType as updateMaintenanceTypeApi,
	deleteMaintenanceType as deleteMaintenanceTypeApi,
} from '../../helpers/establishment/backend_helper';

export const getMaintenanceTypeList = createAsyncThunk('maintenanceType/getMaintenanceTypeList', async () => {
	try {
		const response = getMaintenanceTypeListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getMaintenanceType = createAsyncThunk('maintenanceType/getMaintenanceType', async maintenanceType_id => {
	try {
		const response = getMaintenanceTypeApi(maintenanceType_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewMaintenanceType = createAsyncThunk('maintenanceType/addNewMaintenanceType', async maintenanceType => {
	try {
		const response = addNewMaintenanceTypeApi(maintenanceType);
		toast.success('Tipo de Mantención agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar maintenanceType.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateMaintenanceType = createAsyncThunk('maintenanceType/updateMaintenanceType', async (maintenanceType) => {
		try {
			const response = updateMaintenanceTypeApi(maintenanceType);
			toast.success('Tipo de Mantención actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar maintenanceType.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteMaintenanceType = createAsyncThunk('maintenanceType/deleteMaintenanceType', async maintenanceType => {
	try {
		const response = await deleteMaintenanceTypeApi(maintenanceType);
		toast.success('Tipo de Mantención eliminado exitosamente.', { autoClose: 3000 });
		return { maintenanceType, ...response };
	} catch (error) {
		toast.error('Error al eliminar maintenanceType.', { autoClose: 3000 });
		throw new Error(error);
	}
});


